/* Package JSON Import will be here */
import React from "react";
import { getTranslate } from "react-localize-redux";
import { Row, Col } from "antd";
import { useSelector } from "react-redux";
/* Package JSON Import will be here */

/* Project Import will be here */
import mpLogoBig from "assets/img/mp-logo-big.png";
import image_bimbo_enhanced from "assets/img/imagen-bimbo_enhanced.png";
import UserTokenLogin from "containers/session_jnj/UserTokenLogin";
import AppVersion from "components/reusable/AppVersion";
import DocumentPageTitle from "components/reusable/DocumentPageTitle";
import IvyLogoWithoutName from "assets/img/ivy/ivy-logo-without-name.png";
/* Project Import will be here */

/* Styles will be here */
import "./style/indexStyle.css";
/* Styles will be here */

const QueryStringTokenLogin = (props) => {
    const { translate } = useSelector((state) => ({
        translate: getTranslate(state.locale)
    }));

    const renderComp = () => {
        return (
            <div className="container pl-0 pr-0 mt-0">
                <Row className="flex-grow-wrap">
                    <Col xs={24} sm={24} md={24} lg={14} xl={14} className="grid-col-left">
                        {/* Welcome png and client logo images for web and mobile view */}
                        {/* Web view welcome png */}
                        <div className="text-center mb-2 display-block-web">
                            <img
                                className="product-logo"
                                src={image_bimbo_enhanced}
                                alt={translate("common.imageAlt.clientLogo")}
                            />
                        </div>

                        {/* mobile view welcome png or client logo */}
                        <div className="text-center display-block-mobile">
                            <img
                                className="client-product-logo p-3"
                                src={window.clientLogoUrl !== "" ? window.clientLogoUrl : image_bimbo_enhanced}
                                alt={translate("common.imageAlt.clientLogo")}
                            />
                        </div>
                    </Col>

                    <Col xs={24} sm={24} md={24} lg={10} xl={10} className="grid-col-right">
                        <div className="login-container-width">
                            {/* Client Logo */}
                            <div className="text-center mb-3 display-block-web">
                                <img
                                    className="client-logo"
                                    src={window.clientLogoUrl !== "" ? window.clientLogoUrl : mpLogoBig}
                                    alt={translate("common.imageAlt.clientLogo")}
                                />
                            </div>

                            {/* UserTokenLogin Form */}
                            <div className="p-2">
                                <UserTokenLogin />
                            </div>

                            <div className="footer-login-page">
                                {/* Version Number */}
                                <AppVersion isFromDrawer={false} />

                                {/* Copyrights footer */}
                                <div className="login-copyright-footer font-10">
                                    <img className="copyright-footer-img cursor-pointer" src={IvyLogoWithoutName} alt={translate("common.imageAlt.ivyLogo")} />
                                    {translate("common.copyrightMessage", { year: new Date().getFullYear() })}
                                </div>
                            </div>
                        </div>
                    </Col>
                </Row>
            </div>
        )
    }

    return (
        <React.Fragment>
            {/* Set page title */}
            <DocumentPageTitle {...props} />

            {renderComp()}
        </React.Fragment>
    )
}

export default QueryStringTokenLogin;